
import React from "react";
import { Link } from "react-router-dom";
import pseudoNextLogo from "../assets/pseudonextlogo.png";

const Footer = () => {
    const year = new Date().getFullYear();

    return (
        <footer className="site-footer">
            <div className="social-footer">
                <a href="https://discord.com/" aria-label="Discord">Discord</a>
                <a href="https://x.com/" aria-label="X">X</a>
                <a href="https://facebook.com/" aria-label="Facebook">Facebook</a>
                <a href="https://instagram.com/" aria-label="Instagram">Instagram</a>
                <a href="https://youtube.com/" aria-label="YouTube">YouTube</a>
                <a href="https://twitch.tv/" aria-label="Twitch">Twitch</a>
            </div>

            <div className="footer-content">
                <div className="footer-game-links">
                    <h3>Conquest &amp; Virtue</h3>
                    <div className="footer-link-columns">
                        <div>
                            <Link to="/">Overview</Link>
                            <Link to="/world">The World</Link>
                            <Link to="/armies-warfare">Armies &amp; Warfare</Link>
                            <Link to="/economy-strategy">Economy &amp; Strategy</Link>
                        </div>
                        <div>
                            <Link to="/progression-discovery">Progression &amp; Discovery</Link>
                            <Link to="/shrines-victory">Shrines &amp; Victory</Link>
                            <Link to="/news">News</Link>
                            <Link to="/forums">Forums</Link>
                        </div>
                        <div>
                            <Link to="/shop">Shop</Link>
                            <Link to="/champions">Wall of Champions</Link>
                            <Link to="/support">Support</Link>
                        </div>
                    </div>
                </div>

                <div className="footer-company-links">
                    <a href="/" className="company-logo">
                        <img src={pseudoNextLogo} alt="PseudoNext" />
                    </a>
                    <h3>PseudoNext</h3>
                    <Link to="/about">About</Link>
                    <Link to="/careers">Careers</Link>
                    <Link to="/support">Contact Support</Link>
                </div>
            </div>

            <div className="footer-bottom">
                <p>
                    © {year} PseudoNext. All rights reserved.
                </p>
                <div>
                    <Link to="/privacy">Privacy Policy</Link>
                    <span aria-hidden="true">|</span>
                    <Link to="/terms">Terms &amp; Conditions</Link>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
